import { useState } from 'react';
import { Button } from '@/kit/Button';
import { Icon } from '@/kit/Icon';
import { DialogClose, DialogContent, type DialogComponentProps } from '@/kit/dialog';

/**
 * Angular ConfirmationComponent: warns that the values already entered are replaced (before a file import or a carry
 * forward). Closes with true on OK; the caller treats only exactly true as confirmed.
 */
export function Confirmation({ dialogRef }: DialogComponentProps<undefined, boolean>) {
  const [closing, setClosing] = useState(false);
  return (
    <div className="mat-dialog-wrapper new-account">
      <DialogContent>
        <form onSubmit={(event) => event.preventDefault()}>
          <div className="main-contain">
            <div className="sidenav-header">
              <div className="d-flex align-items-center justify-space-between">
                <h2 className="m-0">
                  <span>Confirmation</span>
                </h2>
                <DialogClose>
                  <Icon name="close" className="close" />
                </DialogClose>
              </div>
            </div>
          </div>
          <div className="sidenav-body">
            <p className="pt-1 pb-2">Note: All Entered Values will be removed</p>
          </div>

          <div className="d-flex gap-15 hr-top pt-1 mt-1">
            <Button className="action-button primary-button" type="button"
              busy={closing}
              onClick={() => {
                setClosing(true);
                dialogRef.close(true);
              }}
            >
              OK
            </Button>
            <DialogClose as="button" type="button" className="action-button secondary-button">
              Cancel
            </DialogClose>
          </div>
        </form>
      </DialogContent>
    </div>
  );
}
